import { create } from 'zustand';

interface LastViewedTeacherState {
  lastViewedTeacherId: number | null;
  setLastViewedTeacherId: (teacherId: number) => void;
}

export const useLastViewedTeacherStore = create<LastViewedTeacherState>((set) => ({
  lastViewedTeacherId: null,
  setLastViewedTeacherId: (teacherId) => set({ lastViewedTeacherId: teacherId }),
}));
